// Extend Chakra to include Finley colors, fonts, etc
export const colors = {
  // core colors: main UI colors
  white: '#FFFFFF',
  /** @deprecated Use colors.gray */
  black: {
    10: '#F6F6F6',
    20: '#ECECEC',
    30: '#E3E3E3',
    40: '#DADADA',
    50: '#C7C7C7',
    60: '#B5B5B5',
    70: '#737373',
    80: '#40413E',
    95: '#0E0E0E',
  },
  /** @deprecated Use colors.red */
  error: 'red.400',
  /** @deprecated Use colors.green */
  success: 'green.400',
  /** @deprecated Use colors.yellow */
  warning: 'orange.400',
  /** @deprecated Use colors.blue */
  info: 'blue.400',
  /** @deprecated Use colors.gray */
  background: {
    50: '#FDFCF9',
    100: '#FAF7F3',
    200: '#F7F4EE',
    300: '#F4F1EA',
    400: '#F9F6F1',
    500: '#E7E3DE',
    600: '#E4E0DA',
    700: '#DCD9D4',
    800: '#D4D0CB',
    900: '#C1BDB8',
  },
  /** @deprecated Use colors.gray */
  tableHeader: '#FAFAFA',
  red: {
    50: '#FFE5E5',
    100: '#FFCCCC',
    200: '#FF7373',
    300: '#F55656',
    400: '#DB3737',
    500: '#C23030',
    600: '#A82A2A',
    700: '#9B2C2C',
    800: '#822727',
    900: '#63171B',
  },

  orange: {
    50: '#FFF2E5',
    75: '#F7E0B4',
    100: '#FFE1C2',
    200: '#FFB366',
    300: '#F29D49',
    400: '#D9822B',
    500: '#BF7326',
    600: '#A66321',
    700: '#9C4221',
    800: '#7B341E',
    900: '#652B19',
  },
  green: {
    50: '#E6FEF4',
    100: '#BDFAE1',
    200: '#3DCC91',
    300: '#15B371',
    400: '#0F9960',
    500: '#0D8050',
    600: '#0A6640',
    700: '#276749',
    800: '#22543D',
    900: '#1C4532',
  },
  blue: {
    50: '#E6F5FE',
    100: '#BDE2FA',
    200: '#48AFF0',
    300: '#2B95D6',
    400: '#137CBD',
    500: '#106BA3',
    600: '#0E5A8A',
    700: '#2c5282',
    800: '#2a4365',
    900: '#1A365D',
  },
  gray: {
    20: '#FAFAFA',
    50: '#F2F2F2',
    100: '#E6E6E6',
    200: '#D1D1D1',
    300: '#B8B8B8',
    400: '#9E9E9E',
    500: '#808080',
    600: '#666666',
    700: '#4D4D4D',
    800: '#333333',
    900: '#1A1A1A',
    950: '#0F0F0F',
  },
  // brand colors
  poppy: {
    50: '#FDF7ED',
    300: '#F4C671', // brand guide Poppy 30
    400: '#EBB347', // brand guide Poppy 40
    500: '#D99C26', // brand guide Poppy 50
  },
  sage: {
    50: '#F8FAF6', // brand guide Sage 02
    100: '#DFE4D5', // brand guide Sage 10
  },
  /** @deprecated Use colors['v2-aurora'] */
  aurora: {
    50: '#E6ECED',
    75: '#97B2B5',
    100: '#4D8F99',
    200: '#2D6469',
    400: '#012E32',
    500: '#012E32',
    800: '#02444A', // brand guide Aurora 75
    900: '#012E32', // brand guide Aurora 90
  },
  'v2-aurora': {
    50: '#E6ECED',
    100: '#CCDADB',
    200: '#97B2B5',
    300: '#678F92',
    400: '#2D6469',
    500: '#02444A',
    600: '#02363B',
    700: '#012E32',
    800: '#011B1E',
    900: '#000E0F',
  },
  /** @deprecated Use light variants from colors.gray or colors['v2-aurora'], depending on your use case */
  millet: {
    50: '#FBFAF9', // brand guide Millet 02
    100: '#F9F6F1', // brand guide Millet 04
    200: '#F3F0ED', // brand guide Millet 06
  },
  // extended colors: brand colors, background colors, or colors reserved for data visualizations
  vermillion: {
    100: '#FFB7A5',
    200: '#F4A691',
    300: '#E9947D',
    400: '#DD836A',
    500: '#D17257',
    600: '#C56145',
    700: '#B85033',
    800: '#AB3E21',
    900: '#9E2B0E',
  },
  rose: {
    100: '#FFB3D0',
    200: '#F5A2C0',
    300: '#EB91AF',
    400: '#E080A0',
    500: '#D56F90',
    600: '#CA5D81',
    700: '#BF4B72',
    800: '#B43863',
    900: '#A82255',
  },
  brick: {
    50: '#FEF8F8',
    100: '#FDF0F0',
    150: '#FDE9E9',
    200: '#FCE1E1',
    300: '#FAD2D2',
    400: '#F9C3C3',
    500: '#FF9B9B',
    600: '#E57373',
    700: '#C25B5B',
    800: '#A54242',
    850: '#9D3F3F',
    900: '#912E2E',
    950: '#863030',
  },
  violet: {
    100: '#E1BAE1',
    200: '#D0A6CF',
    300: '#BF93BE',
    400: '#AE80AD',
    500: '#9D6D9C',
    600: '#8C5B8C',
    700: '#7C497B',
    800: '#6C376B',
    900: '#5C255C',
  },
  indigo: {
    100: '#D6CCFF',
    200: '#C6BAF4',
    300: '#B7A8E8',
    400: '#A796DD',
    500: '#9784D2',
    600: '#8773C7',
    700: '#7763BC',
    800: '#6752B1',
    900: '#5642A6',
  },
  cobalt: {
    100: '#B3CFFF',
    200: '#A2BDF2',
    300: '#91ACE5',
    400: '#809BD8',
    500: '#6F8ACB',
    600: '#5E79BE',
    700: '#4B6AB2',
    800: '#385AA5',
    900: '#1F4B99',
  },
  turquoise: {
    100: '#87E4DB',
    200: '#78D5CC',
    300: '#68C6BD',
    400: '#58B8AE',
    500: '#47AA9F',
    600: '#369C91',
    700: '#369C91',
    800: '#228E83',
    900: '#008075',
  },
  forest: {
    100: '#B1ECB5',
    200: '#9FDCA2',
    300: '#8DCD8F',
    400: '#7CBD7D',
    500: '#6AAE6A',
    600: '#589F59',
    700: '#469047',
    800: '#338136',
    900: '#1D7324',
  },
  lime: {
    100: '#E8F9B6',
    200: '#D9EBA3',
    300: '#CADD91',
    400: '#BBCF7F',
    500: '#ADC16D',
    600: '#9EB45B',
    700: '#8FA649',
    800: '#819937',
    900: '#728C23',
  },
  gold: {
    100: '#FFE4A0',
    200: '#F4D68E',
    300: '#EAC87D',
    400: '#DFBA6B',
    500: '#D4AD5A',
    600: '#C8A048',
    700: '#BD9336',
    800: '#B28623',
    900: '#A67908',
  },
  sepia: {
    100: '#E4CBB2',
    200: '#D4B89E',
    300: '#C3A68A',
    400: '#B39477',
    500: '#A38364',
    600: '#937252',
    700: '#836140',
    800: '#73512F',
    900: '#63411E',
  },
  chart: {
    celadon: '#B4F7BA',
    cream: '#F7ECB4',
    sky: '#B4E1F7',
    lilac: '#BFB4F7',
    blush: '#F7D0B4',
    coral: '#FFA690',
    slateBlue: '#7F9EBF',
    dustyRose: '#F7B4C4',
    teal: '#B4F7F1',
    jasmine: '#CAF7B4',
    yellow: '#FFE6A0',
    mint: '#B4F7D5',
    lavender: '#E0B4F7',
    peach: '#FFCBA0',
    // Todo: update all charts to v2 colors at some point
    // Mapping on figma: https://www.figma.com/file/Bb83U2hoFkfEiEpqGxptVf/Lender-Dashboard?node-id=3366%3A50266&mode=dev
    // Judy's v2 colors, as of 2024-09-3
    pink: '#FFA0DC',
    paleViolet: '#D2A0FF',
    winter: '#A0E6FF',
  },
  /** @deprecated Use colors.gray or colors['v2-aurora'] */
  secondary: {
    100: '#F3D394',
  },
} as const;

/** @deprecated We don't use 8-digit hex codes for alpha values */
export const transparency = {
  100: 'FF',
  95: 'F2',
  90: 'E6',
  85: 'D9',
  80: 'CC',
  75: 'BF',
  70: 'B3',
  65: 'A6',
  60: '99',
  55: '8C',
  50: '80',
  45: '73',
  40: '66',
  35: '59',
  30: '4D',
  25: '40',
  20: '33',
  15: '26',
  10: '1A',
  5: '0D',
  0: '00',
};
